<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">添加设备</div>
    </div>
    <div >
      <img class="banner" src="../../assets/imgs/addDeviceBg.png">
    </div>
    <div>
      <div class="bind-box">
        <div class="device-no">{{i18nActivation.device_sn}}:</div>
        <van-field type="text" v-model="deviceSn" class="device-input" :use-right-icon-slot = 'true'>
          <template #right-icon >
            <van-image style="margin-top: -5px" :src="require('assets/imgs/icon_Scan.png')" width="3em" height="3em" @click="scanQr"></van-image>
          </template>
        </van-field>
      </div>
      <div class="method" @click="show = true">{{i18nActivation.viewing_methods}}</div>
    </div>
    <div class="activity-foot">
      <button class="activation-btn"  style="background: #1EBE86;" @click="toBind">{{i18nActivation.binding}}</button>
      <div class="go-home" @click="backHome">
        <img src="../../assets/imgs/go_back_home.png" @click="onBack">
        <label class="content">{{i18nActivation.back_to_home}}</label>
      </div>
    </div>
    <van-dialog v-model="show" title="" :show-cancel-button="false" :show-confirm-button="false" width="380px">
      <van-icon name="cross" class="cross-btn" @click="show = false" />
      <div class="package-title">
        {{i18nActivation.viewing_methods}}
      </div>
      <div class="method-box">
        <van-image :src="require('assets/imgs/ud_device_bkg.png')" width="105px"></van-image>
        <van-image :src="require('assets/imgs/ud_device_bgk1.png')" class="method-img-r" ></van-image>
        <div class="method-label">{{i18nActivation.scan_the_qr_code}}</div>
      </div>
    </van-dialog>
    <div class="fixed" v-if="isPickUpShow" @click="stop">
      <div id="reader"></div>
    </div>
  </div>
</template>

<script>
import { baseURL } from '../../utils/http'
import { USER_CAPTCHA, SEND_CODE, USER_INFO } from '../../apis/user'
import ScanQr from 'views/scanQr/scanQr.vue'
import ScanHtml5Qr from 'views/scanHtml5Qr/scanHtml5Qr.vue'
import { mapState } from 'vuex'
import { generateUUID } from '@/utils'
import { MIFI_BIND, MIFI_PICKUP, MIFI_QR_CODE } from '@/apis/cabinet'
import { WECHAT_MP_PRE_PAY } from '@/apis/payment'
import { Html5Qrcode } from "html5-qrcode";
export default {
  components: {
  //  ScanQr,
  //  ScanHtml5Qr
  },
  computed: {
    ...mapState(['user', 'browser', 'system']),
    ...mapState(['mifisn']),
    i18n () {
      return this.$t('login')
    },
    i18nActivation() {
      return this.$t('activation')
    }
  },
  watch: {
    user (val, oldVal) {
      if (val && !oldVal) {
        this.$router.push('/')
      }
    }
  },
  data () {
    return {
      phone: '',
      show: false,
      captchaUrl: '',
      email: '',
      sn: '',
      verifyCode: '',
      code: '',
      isPickUpShow: false,
      deviceSn: '',
      isSHowCode: true,
      send: 'Send',
      disabled: false,
      count: 59,
      timer: null,
      checkDisabled: true
    }
  },
  methods: {
    getResult(result) {
      this.deviceSn = result
      this.isPickUpShow = false
      this.stop()
    },
    onBack () {
      if (this.mifisn) {
        this.$router.go(-1)
      }
    },
    toBind () {
      this.$loading(true)
      if (this.deviceSn === "") {
        this.$toast("请扫码")
        this.$loading(false)
        return
      }
      let url = `${MIFI_BIND}`
      this.$post(url, {
          devId: this.deviceSn
        }, res => {
          this.$loading(false)
          this.$router.go(-1)
        },
        err => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    scanQr() {
      this.isPickUpShow = true
      this.getCameras()
    },
    backHome() {
      if (this.mifisn) {
        this.$router.push('/')
      }
    },
    getCameras() {
      Html5Qrcode.getCameras().then((devices) => {
          if (devices && devices.length) {
            this.html5QrCode = new Html5Qrcode("reader");
            this.start();
          } else {
            console.log(devices)
          }
        })
    },
    start() {
      var $this = this
      this.html5QrCode
        .start(
          { facingMode: "environment" },
          {
            fps: 2,
            qrbox: { width: 300, height: 50 }
          },
          (decodedText, decodedResult) => {
            console.log(decodedText)
            $this.deviceSn = decodedText
            $this.isPickUpShow = false
            $this.stop()
          }
        ).catch((err) => {
        this.$emit("err", err)
      })
    },
    stop() {
      if (this.html5QrCode.isScanning) {
        this.html5QrCode.stop().then((ignore) => {
          console.log("QR Code scanning stopped.");
        })
      }
      this.isPickUpShow = false
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
.activity-warp {
  height: 100vh;
 // background: linear-gradient(#00AB46, #1A2229);
  .activity-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    .backicon{
      width: 50px;
    }
    .activity-title{
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
  .welcome{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 56px;
    color: #333333;
    width: 90%;
    margin: 40px auto 0;
  }
  .content{
    font-family: Montserrat, Montserrat;
    font-weight: 500;
    font-size: 30px;
    color: #333333;
    width: 90%;
    margin: 40px auto 0  ;
  }
  .banner{
    width: 100%;
    display: block;
  }
  .logowhite{
    width: 15%;
    display: block;
    margin: 0 auto;
  }
  .activity-foot {
    width: 90%;
    margin: 40px auto 0;
    .appleloginbtn2{
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      margin: 40px 0 0;
      img{
        width: 50px;
        margin-right: 20px;
      }
    }
    .foot-bottom{
      bottom: 0;
      position: absolute;
      left: 0;
      right: 0;
      text-align: center;
    }
    .appleloginbtn{
      width: 100%;
      border: none;
      background: #fff;
      color: #000;
      img{
        width: 60px;
        margin-right: 20px;
      }
    }
    .otherlogin{
      width: 100%;
      border: none;
      background: #00AB46;
      color: #fff;
      margin: 40px 0 0;
    }
    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .activation-btn{
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 40px;
      color: #FFFFFF;
      border: none;
      width: 670px;
      height: 98px;
      border-radius: 50px 50px 50px 50px;
    }
    .go-home{
      text-align: center;
      width: 100%;
      margin: 21px auto;
      img{
        width: 34px;
        height: 34px;
        vertical-align: -5px;
        display: inline-block;
      }
      .content{
        font-family: Montserrat, Montserrat;
        font-weight: 400;
        font-size: 28px;
        color: #1EBE86;
        margin-top: -3px;
      }
    }
  }
  .bind-box{
    padding: 20px;
  }
  .device-no{
    font-family: MyFont3;
    font-weight: bold;
    font-size: 30px;
    color: #1A2229;
  }
  .device-input{
    width: 100%;
    line-height: 20px;
    background: #FFFFFF;
    border-radius: 49px 49px 49px 49px;
    border: 2px solid #D1D1D1;
    margin-top: 20px;
  }
  .method{
    text-align: center;
    font-family: MyFont2;
    font-weight: 400;
    font-size: 28px;
    color: #1EBE86;
    padding-top: 28px;
  }
  .send-btn{
    border: none;
    background: #ffffff;
    color: #1EBE86;
    font-size: 26px;
  }
}
.package-title{
  text-align: center;
  padding: 30px 40px 30px 40px;
  font-family: MyFont2;
  color: #333333;
  font-weight: bold;
  font-size: 36px;
}
.cross-btn{
  position: absolute;
  right: 30px;
  top: 30px;
  font-size: 40px;
}
.method-img-r{
  position: absolute;
  margin-left: 85px;
  width: 244px;
}
.method-box{
  padding: 20px 20px 40px 20px;
  .method-label{
    font-family: Montserrat, Montserrat;
    font-weight: 400;
    font-size: 22px;
    color: #333333;
    width: 4.2rem;
    margin-left: 3.5rem;
    margin-top: -1.3rem;
  }
}
.login-code {
  img {
    width: 180px;
    height: 60px;
    border: none;
    margin-top: -3px;
  }
}
.activity-foot {
  width: 90%;
  margin: 40px auto 0;
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  .activation-btn{
    font-family: Montserrat, Montserrat;
    font-weight: bold;
    font-size: 40px;
    color: #FFFFFF;
    border: none;
    width: 670px;
    height: 98px;
    background: #1EBE86;
    border-radius: 50px 50px 50px 50px;
    margin-top: 49px;
  }
  .go-home{
    text-align: center;
    width: 100%;
    margin: 21px auto;
    img{
      width: 34px;
      height: 34px;
      vertical-align: -5px;
      display: inline-block;
    }
    .content{
      font-family: Montserrat, Montserrat;
      font-weight: 400;
      font-size: 28px;
      color: #1EBE86;
      margin-top: -3px;
    }
  }
}
.fixed{
  position: fixed;
  bottom: 0;
  width: 100%;
  // background: rgba(45, 45, 45, 0.5);
  height: 100%;
}
.qrcode {
  position: relative;
  height: 100%;
  width: 100%;
  //background: rgba($color: #000000, $alpha: 0.48);
}
#reader {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
</style>
